export default __webpack_public_path__ + "static/O0110-15e795dc0265cb7ad31bb62878568025.png";